import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

const PostHogPageview = () => {
    const location = useLocation();
    const posthog = usePostHog();

    useEffect(() => {
        if (posthog) {
            // Track page view with current URL
            posthog.capture('$pageview');
        }
    }, [location, posthog]);

    return null;
}

export default PostHogPageview;
